import SearchFilterBar from '../../components/ui/search-filter-bar'
import Pagination from '../../components/ui/pagination'
import { useRequestAmendmentData } from '../../hooks/data-table/use-request-amendment-data.ts'
import { requestAmendmentThead } from '../../constant/acturial'
import RequestAmendTbody from '../../components/module/request-amendments/request-amend-tbody'
import RequestAmendmentModal from '../../components/module/request-amendments/modal/request-amend/request-amendment-modal'
import { useSelector } from 'react-redux'
import { selectAmendmentModal, selectSubAmendmentModal } from '../../features/actuarial/request-amendment/request-amendment.slice'
import SectionHeader from '../../components/ui/section-header'
import ProposeAndCurrentData from '../../components/module/request-amendments/modal/request-amend/propose-and-current-data'
import ProposalTHead from '../../components/ui/proposal-thead'
import { proposalHeaderData } from '../../constant/gms-constant'

export default function RequestAmendmentsPage() {
    
    const amendmentModal = useSelector(selectAmendmentModal);
    const subAmendmentModal = useSelector(selectSubAmendmentModal);
    const {
        normalizedOptions,
        errorMessageGetRequestAmendments,
        searchType,
        setSearchType,
        searchValue,
        setSearchValue,
        setPage,
        pagedData,
        loading,
        isErrorGetRequestAmendments,
        handleReload,
        getRequestAmendments,

        defaultTotalPages,
        proposalDefaultPageSize,
        handleChangePageSize
    } = useRequestAmendmentData(); 
    
    return (
        <div className="flex h-full min-h-0 w-full flex-col bg-[#f8fafc] rounded-xl border border-gray-200">
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                <SectionHeader
                    title='Request amendments'
                    subtitle='Review submitted proposals, request amendments, and monitor the status of amendment requests.'
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 20h4l10.5-10.5a2.12 2.12 0 0 0-3-3L5 17v3Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="m13.5 7.5 3 3" />
                        </svg>
                    }
                />
                <div className="mx-auto flex min-h-0 w-full flex-1 flex-col gap-2">
                    <div className="flex min-h-0 flex-1 flex-col overflow-hidden bg-white shadow-sm">
                        <div className="shrink-0 border-b border-gray-200 p-3">
                            <SearchFilterBar
                                searchType={searchType}
                                setSearchType={setSearchType}
                                searchValue={searchValue}
                                setSearchValue={setSearchValue}
                                options={normalizedOptions}
                            />
                        </div>
                        {getRequestAmendments?.pagination && (
                            <div className="shrink-0 border-b border-gray-200 bg-gray-50/60 p-3">
                                <Pagination
                                    setPage={setPage}
                                    handleReload={handleReload}
                                    pagination={getRequestAmendments.pagination}
                                    defaultTotalPages={defaultTotalPages}
                                    setDefaultTotalPages={handleChangePageSize}
                                    totalPagesOptions={proposalDefaultPageSize}
                                />
                            </div>
                        )}
                        <div className="min-h-0 flex-1 overflow-auto">
                            <table className="min-w-max w-full border-collapse">
                                <ProposalTHead
                                    headers={[
                                        proposalHeaderData.status.label,
                                        proposalHeaderData.notes.label,
                                        proposalHeaderData.proposalAs.label,
                                        proposalHeaderData.groupName.label,
                                        proposalHeaderData.product.label,
                                        proposalHeaderData.preparedBy.label,
                                    ]}
                                />
                                <RequestAmendTbody
                                    isLoading={loading}
                                    isError={isErrorGetRequestAmendments}
                                    errorMessage={errorMessageGetRequestAmendments}
                                    data={pagedData}
                                    theadLength={requestAmendmentThead.length}
                                />
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {amendmentModal === 'showAmendmentDetails' && ( <RequestAmendmentModal/> )}
            {subAmendmentModal === 'viewProposeData' && (<ProposeAndCurrentData/>)}
        </div>
    )
}
